<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Review Self Appraisal
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row class="sub-row" justify="center" dense>
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b>Academic Year</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="academicyear" :items="aylist"
                        item-text="ay" item-value="id" label="Academic Year" outlined />
                </v-col>
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b>Instructor List</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" return-object
                        :items="instructor_list" item-text="name" item-value="id" label="Instructor" outlined />
                </v-col>
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b></b></p><br>
                    <v-btn color="brand onBrand--text" dense rounded :loading="loader" @click="fetchSelfAppriasalData">
                        Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="selfAuthoritymarks.length > 0">
            <v-data-table :headers="headers" :items="selfAuthoritymarks" sort-by="srno" class="elevation-1">
                <template v-slot:top>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Marks
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.proceed`]="{ item }">
                    <v-btn class="button" :loading="proceed_loader" @click="proceed(item)">Proceed</v-btn>
                </template>
            </v-data-table>
        </v-card>
        <v-form id="payment-form" @submit.prevent="submit" ref="admissionfeeform">
            <v-card class="box" v-if="this.show_table == true">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Fill Self Appraisal
                        </strong>
                    </v-toolbar-title>
                </v-toolbar><br>
                <v-simple-table class="elevation-1">
                    <template>
                        <thead>
                            <tr>
                                <th class="text-left table-head">Sr. No.</th>
                                <th class="text-left table-head">Parameter</th>
                                <!-- <th class="text-left table-head">Sub Parameters</th> -->
                                <th class="text-left table-head">Max Marks</th>
                                <th class="text-left table-head">Self Marks</th>
                                <th class="text-left table-head">Self Re-Marks</th>
                                <th class="text-left table-head">Authority Marks</th>
                                <th class="text-left table-head">Authority ReMark</th>
                                <th class="text-left table-head">Evidences</th>
                            </tr>
                        </thead>

                        <tbody v-for="(item,i) in all_data_list" :key="item">
                            <tr>
                                <td>{{i+1}}</td>
                                <td>{{item.parameter_name}}</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr v-for="(topic) in item.sublist" :key="topic.coordinator_Marks_id">
                                <td><input type="hidden" name="coordinator_Marks_id"
                                        :value="topic.coordinator_Marks_id"> </td>
                                <!-- <td></td> -->
                                <td><span>{{topic.subparameter_no}}.</span>{{topic.subparameter_name}}</td>
                                <td>{{topic.marks}}</td>
                                <td>{{topic.authorityMarks}}</td>
                                <td>{{topic.authorityRemarks}}</td>
                                <td> <v-row dense>
                                        <v-col cols="10" xs="10" sm="10" lg="10" md="10">
                                            <v-text-field class="padding-bot" outlined dense type="number"
                                                v-model="topic.coordinator_Marks" name="coordinator_Marks"
                                                :rules="[v => v <= topic.marks || 'Marks should be Less Than Max Marks']"></v-text-field>
                                        </v-col> </v-row></td>
                                <td><v-row dense>
                                        <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                                            <v-text-field class="padding-bot" outlined dense type="text"
                                                v-model="topic.coordinator_Remarks"
                                                name="coordinator_Remarks"></v-text-field>
                                        </v-col> </v-row></td>

                                <td><v-row dense>
                                        <span v-if="topic.filepath!=null">
                                            <span v-for="(item,i) in topic.filepath" :key="item">
                                                <a class="p-2" :href="basepath+item+topic.filename[i]" target="blank">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn icon v-if="topic.filepath!=null" v-bind="attrs"
                                                                v-on="on"> <v-icon
                                                                    color="black">mdi-eye</v-icon></v-btn>
                                                        </template>
                                                        <span>
                                                            View Attachment File!!!
                                                        </span>
                                                    </v-tooltip>
                                                </a>
                                                <!-- </span> -->
                                            </span>
                                        </span>
                                    </v-row>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <v-row class="sub-row" justify="center" dense>
                    <v-col cols="12" xs="12" sm="2" lg="3" md="3">
                    </v-col>
                    <v-col cols="12" xs="12" sm="3" lg="4" md="12">
                        <v-btn class="button" @click="submit" rounded :loading="loader">Save</v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-form>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
  data: () => ({
    loader: false,
    proceed_loader: false,
    search: "",
    snackbar_msg: "",
    snackbar: false,
      color: "",
    //   extraBreadcrumbItems: [
         

    //   ],
    //   breadcrumbClass: "breadcrumb-style1",
    aylist:[],
    instructor_list:[],
    instructor:"",
    academicyear:"",
    basepath:"",
    selfAuthoritymarks:[],
    all_data_list:[],
    show_table:false,
    headers: [
    { text: "Sr. No.", value: "srno", sortable: "true" },
    { text: "Faculty", value: "instructor", sortable: "true"},
    { text: "Self marks", value: "selfmarks", sortable: "true" },
    { text: "Authority marks", value: "recomondingmarks", sortable: "true" },
    { text: "Proceed", value: "proceed", sortable: "true" },
    ],
  }),
  methods: {
        submit: function (e) {
            var form = document.getElementById("payment-form");
            var formData = new FormData(form);
           axios
        .post("/FillSelfAppriasal/Save_recommending_Marks",formData)
        .then((res) => {
            if (res.data.flag == "YES") {
                this.loader=false
                this.all_data_list=res.data.final_List
                this.showSnackbar("#4caf50", "Saved Successfully...!");
            }else if(res.data.flag == "No"){
                this.loader=false
                this.showSnackbar("#b71c1c", res.data.snackbar);
                this.all_data_list=res.data.final_List
            } 
            else {
                //   window.console.log(res.data.msg);
                this.showSnackbar("#b71c1c", "Something went wrong!");
            }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {});
      },
    proceed(item){
    this.proceed_loader=true
    this.all_data_list=[]
    const formData = {
        ay: this.academicyear,
        inst_id: item.id        
    };
    axios
    .post("/FillSelfAppriasal/proceed",formData)
    .then((res) => {
        if (res.data.flag == "YES") {
             this.proceed_loader=false
             this.all_data_list=res.data.final_List
             this.show_table=true
        }else if(res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            this.proceed_loader=false
            this.all_data_list=[]
        }else {
            this.loader=false
            this.show_table=false
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {});
    },
    fetchSelfAppriasalData(){
    this.loader=true
    const formData = {
        ay: this.academicyear,
        instructor: this.instructor.id,
    };
    axios
    .post("/FillSelfAppriasal/fetchSelfAppriasalData",formData)
    .then((res) => {
        if (res.data.flag == "YES") {
             this.loader=false
             this.selfAuthoritymarks=res.data.selfAuthoritymarks
        } else {
            this.loader=false
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {});
    },

    onLoad() {
axios
    .post("/FillSelfAppriasal/getData")
    .then((res) => {
        if (res.data.flag == "YES") {
            this.aylist=res.data.aylist
            this.basepath = res.data.aws_path;
            this.instructor_list=res.data.instructor_list_recommending
            this.academicyear=res.data.cay
        } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {});
    },
    showSnackbar(clr, msg) {
    this.snackbar = true;
    this.color = clr;
    this.snackbar_msg = msg;
},
  },
   mounted() {
    this.onLoad();
    },
};
</script>
<style scoped>
.tc-title {
        background-image: linear-gradient(-90deg, #fff, blue);
        color: #fff;
        border-radius: 3px;
    }

    .table-head {
    background: #0f2027; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    color: white  !important;
    }
    .textcolor{
        color: darkblue;
        font-weight: bold;
    }
      td,
    th {
        border: 1px solid #ccc;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        font-weight: bold;
    }
    td{
        margin: 1rem !important;
        padding: 1rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
sub-row {
        border: 2px solid #424093;
        margin: 1rem;
        border-radius: 5px;
    }

    i {
        font-size: 20px !important;
    }

    .v-card__title {
        border: 1px solid #80808040;
        font-weight: bold;
        background-color: #424093;
        color: white;
        text-align: center;
        /* margin-top: 1.5rem; */
    }
    .card-border {
        border: 2px solid darkblue;
        border-radius: 10px;
        /* padding: 5px; */
        /* margin: 1rem !important; */
        width: auto;
    }

    .tx-bold {
        font-weight: bold;
        font-size: 14px;
        color: black;
    }

    i {
        font-size: 26px;
        cursor: pointer;
    }

    theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #424093 !important;
        color: white !important;
        margin-top: 2.35rem;
        border-radius: 20px;
    }

    /*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

    @media only screen and (max-width: 600px) {
    }

    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
        cursor: zoom-in;
    }

    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: auto;
    }

    v-simple-table {
        border-collapse: collapse;
        border-spacing: 0;
        width: auto;
        border: 1px solid #ddd;
    }

    th {
        color: white;
        font-weight: bold;
        text-align: center !important;
    }

    td,
    th {
        padding: 6px;
        border: 1px solid #ccc;
        text-align: center;
    }
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    @media all and (min-width: 1000px) {
        .padding-metting {
            padding-right: 22px;
        }
    }
    @media (min-width: 320px) and (max-width: 350px) {
        .padding-bot {
            font-size: 11.6px;
        }
    }
    @media (min-width: 1000px) and (max-width: 1050px) {
        .padding-bot {
            font-size: 9.6px;
        }
    }
     .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }


</style>
